import React from 'react';
import { StateLabel } from '@common/components';
import { InvoiceStateType } from '@pay-bill/graphql';

export const INVOICE_COLOR_STYLE_MAP: Record<InvoiceStateType, string> = {
  void: 'midnight-darkest',
  draft: 'sun-darker',
  open: 'sky-regular',
  paid: 'meadow',
  rejected: 'coral',
  resolved: 'meadow-darker',
  paid_off_platform: 'sun-darker',
};

export const INVOICE_LABEL_OVERWRITE: Record<InvoiceStateType, string> = {
  void: 'Voided',
  draft: 'Draft',
  open: 'Open',
  paid: 'Paid',
  rejected: 'Rejected',
  resolved: 'Resolved',
  paid_off_platform: 'Paid Off Platform',
};

export const InvoiceState = ({ state }: { state: InvoiceStateType }) => (
  <StateLabel
    state={INVOICE_LABEL_OVERWRITE[state] || state}
    color={INVOICE_COLOR_STYLE_MAP[state]}
  />
);
